export const SOURCE_CATALOG_URL = 'source-catalog'
